<mat-toolbar class="p8-bdc_setting-footer__container">
  <ng-content></ng-content>
</mat-toolbar>
